import { css } from "@emotion/react";

// These styles need to override the global styles
export const IndexStyles = css`
  h2 {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  a,
  a:visited {
    color: rgb(16, 93, 216);
  }
`;
